import { DetailedHTMLProps, HTMLAttributes, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../../../utils';
import { FieldBase, IFieldBaseProps } from '../Base';
import { rangeStyles } from './styles';

export interface IRangeFieldProps
  extends DetailedHTMLProps<
      Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
      HTMLInputElement
    >,
    VariantProps<typeof rangeStyles.input> {
  containerProps?: {
    className?: string;
    rest?: Omit<IFieldBaseProps, 'className'>;
  };
  outputProps?: {
    className?: string;
    rest?: HTMLAttributes<HTMLOutputElement>;
  };
  outputValue?: string;
}

export function RangeField({
  className,
  containerProps,
  design,
  disabled = false,
  inputSize,
  name,
  outputProps,
  outputValue,
  readOnly = false,
  ...rest
}: IRangeFieldProps): JSX.Element {
  return (
    <FieldBase
      className={twMerge('mb-5', containerProps?.className)}
      {...containerProps?.rest}
    >
      <IsVisible when={!!outputValue}>
        <output
          className={rangeStyles.output({
            design,
            errored: !!containerProps?.rest?.error,
            className: outputProps?.className,
            size: inputSize,
          })}
          {...outputProps?.rest}
        >
          {outputValue}
        </output>
      </IsVisible>
      <input
        className={rangeStyles.input({
          design,
          disabled: disabled || readOnly,
          errored: !!containerProps?.rest?.error,
          inputSize,
          className,
        })}
        disabled={disabled}
        id={name}
        name={name}
        readOnly={readOnly}
        type="range"
        {...rest}
      />
    </FieldBase>
  );
}
